import { RootAppState } from 'store/configureStore'

export const projectReferenceSelector = (state: RootAppState) => {
  return state.project.activeProject?.projectReference
}
